/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessObjectDefinitionDescriptionSuggestion } from '../model/businessObjectDefinitionDescriptionSuggestion';
import { BusinessObjectDefinitionDescriptionSuggestionAcceptanceRequest } from '../model/businessObjectDefinitionDescriptionSuggestionAcceptanceRequest';
import { BusinessObjectDefinitionDescriptionSuggestionCreateRequest } from '../model/businessObjectDefinitionDescriptionSuggestionCreateRequest';
import { BusinessObjectDefinitionDescriptionSuggestionKeys } from '../model/businessObjectDefinitionDescriptionSuggestionKeys';
import { BusinessObjectDefinitionDescriptionSuggestionSearchRequest } from '../model/businessObjectDefinitionDescriptionSuggestionSearchRequest';
import { BusinessObjectDefinitionDescriptionSuggestionSearchResponse } from '../model/businessObjectDefinitionDescriptionSuggestionSearchResponse';
import { BusinessObjectDefinitionDescriptionSuggestionUpdateRequest } from '../model/businessObjectDefinitionDescriptionSuggestionUpdateRequest';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class BusinessObjectDefinitionDescriptionSuggestionService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * acceptBusinessObjectDefinitionDescriptionSuggestion
     * Accepts suggested business object definition description suggestion by key and updates the corresponding business object definition description.
     * @param businessObjectDefinitionDescriptionSuggestionAcceptanceRequest the information needed to accept the business object definition description suggestion.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionDescriptionSuggestionAcceptBusinessObjectDefinitionDescriptionSuggestion(businessObjectDefinitionDescriptionSuggestionAcceptanceRequest: BusinessObjectDefinitionDescriptionSuggestionAcceptanceRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionDescriptionSuggestion>;
    public businessObjectDefinitionDescriptionSuggestionAcceptBusinessObjectDefinitionDescriptionSuggestion(businessObjectDefinitionDescriptionSuggestionAcceptanceRequest: BusinessObjectDefinitionDescriptionSuggestionAcceptanceRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionAcceptBusinessObjectDefinitionDescriptionSuggestion(businessObjectDefinitionDescriptionSuggestionAcceptanceRequest: BusinessObjectDefinitionDescriptionSuggestionAcceptanceRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionAcceptBusinessObjectDefinitionDescriptionSuggestion(businessObjectDefinitionDescriptionSuggestionAcceptanceRequest: BusinessObjectDefinitionDescriptionSuggestionAcceptanceRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionDescriptionSuggestionAcceptanceRequest === null || businessObjectDefinitionDescriptionSuggestionAcceptanceRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionDescriptionSuggestionAcceptanceRequest was null or undefined when calling businessObjectDefinitionDescriptionSuggestionAcceptBusinessObjectDefinitionDescriptionSuggestion.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDefinitionDescriptionSuggestion>(`${this.configuration.basePath}/businessObjectDefinitionDescriptionSuggestions/acceptance`,
            businessObjectDefinitionDescriptionSuggestionAcceptanceRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createBusinessObjectDefinitionDescriptionSuggestion
     * Creates a new business object definition description suggestion.
     * @param businessObjectDefinitionDescriptionSuggestionCreateRequest the information needed to create the business object definition description suggestion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionDescriptionSuggestionCreateBusinessObjectDefinitionDescriptionSuggestion(businessObjectDefinitionDescriptionSuggestionCreateRequest: BusinessObjectDefinitionDescriptionSuggestionCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionDescriptionSuggestion>;
    public businessObjectDefinitionDescriptionSuggestionCreateBusinessObjectDefinitionDescriptionSuggestion(businessObjectDefinitionDescriptionSuggestionCreateRequest: BusinessObjectDefinitionDescriptionSuggestionCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionCreateBusinessObjectDefinitionDescriptionSuggestion(businessObjectDefinitionDescriptionSuggestionCreateRequest: BusinessObjectDefinitionDescriptionSuggestionCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionCreateBusinessObjectDefinitionDescriptionSuggestion(businessObjectDefinitionDescriptionSuggestionCreateRequest: BusinessObjectDefinitionDescriptionSuggestionCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionDescriptionSuggestionCreateRequest === null || businessObjectDefinitionDescriptionSuggestionCreateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionDescriptionSuggestionCreateRequest was null or undefined when calling businessObjectDefinitionDescriptionSuggestionCreateBusinessObjectDefinitionDescriptionSuggestion.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDefinitionDescriptionSuggestion>(`${this.configuration.basePath}/businessObjectDefinitionDescriptionSuggestions`,
            businessObjectDefinitionDescriptionSuggestionCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteBusinessObjectDefinitionDescriptionSuggestion
     * Deletes an existing business object definition description suggestion by key.
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param userId the user id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionDescriptionSuggestionDeleteBusinessObjectDefinitionDescriptionSuggestion(namespace: string, businessObjectDefinitionName: string, userId: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionDescriptionSuggestion>;
    public businessObjectDefinitionDescriptionSuggestionDeleteBusinessObjectDefinitionDescriptionSuggestion(namespace: string, businessObjectDefinitionName: string, userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionDeleteBusinessObjectDefinitionDescriptionSuggestion(namespace: string, businessObjectDefinitionName: string, userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionDeleteBusinessObjectDefinitionDescriptionSuggestion(namespace: string, businessObjectDefinitionName: string, userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionDescriptionSuggestionDeleteBusinessObjectDefinitionDescriptionSuggestion.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionDescriptionSuggestionDeleteBusinessObjectDefinitionDescriptionSuggestion.');
        }
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling businessObjectDefinitionDescriptionSuggestionDeleteBusinessObjectDefinitionDescriptionSuggestion.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<BusinessObjectDefinitionDescriptionSuggestion>(`${this.configuration.basePath}/businessObjectDefinitionDescriptionSuggestions/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/userIds/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinitionDescriptionSuggestionByKey
     * Retrieves an existing business object definition description suggestion by key.
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param userId the user id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestionByKey(namespace: string, businessObjectDefinitionName: string, userId: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionDescriptionSuggestion>;
    public businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestionByKey(namespace: string, businessObjectDefinitionName: string, userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestionByKey(namespace: string, businessObjectDefinitionName: string, userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestionByKey(namespace: string, businessObjectDefinitionName: string, userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestionByKey.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestionByKey.');
        }
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestionByKey.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinitionDescriptionSuggestion>(`${this.configuration.basePath}/businessObjectDefinitionDescriptionSuggestions/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/userIds/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinitionDescriptionSuggestions
     * Retrieves a list of business object definition description suggestion keys for all suggestions registered for a specific business object definition. The result list is sorted by userId in ascending order.
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestions(namespace: string, businessObjectDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionDescriptionSuggestionKeys>;
    public businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestions(namespace: string, businessObjectDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionDescriptionSuggestionKeys>>;
    public businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestions(namespace: string, businessObjectDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionDescriptionSuggestionKeys>>;
    public businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestions(namespace: string, businessObjectDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestions.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionDescriptionSuggestionGetBusinessObjectDefinitionDescriptionSuggestions.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinitionDescriptionSuggestionKeys>(`${this.configuration.basePath}/businessObjectDefinitionDescriptionSuggestions/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchBusinessObjectDefinitionDescriptionSuggestions
     * Retrieve a list of business object definition description suggestions meeting the search criteria filters and fields request.
     * @param businessObjectDefinitionDescriptionSuggestionSearchRequest the search criteria needed to find a list of business object definition description suggestions
     * @param fields the field options for the business object definition description suggestions search response. The valid field options are: status, descriptionSuggestion, createdByUserId, createdOn
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionDescriptionSuggestionSearchBusinessObjectDefinitionDescriptionSuggestions(businessObjectDefinitionDescriptionSuggestionSearchRequest: BusinessObjectDefinitionDescriptionSuggestionSearchRequest, fields?: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionDescriptionSuggestionSearchResponse>;
    public businessObjectDefinitionDescriptionSuggestionSearchBusinessObjectDefinitionDescriptionSuggestions(businessObjectDefinitionDescriptionSuggestionSearchRequest: BusinessObjectDefinitionDescriptionSuggestionSearchRequest, fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionDescriptionSuggestionSearchResponse>>;
    public businessObjectDefinitionDescriptionSuggestionSearchBusinessObjectDefinitionDescriptionSuggestions(businessObjectDefinitionDescriptionSuggestionSearchRequest: BusinessObjectDefinitionDescriptionSuggestionSearchRequest, fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionDescriptionSuggestionSearchResponse>>;
    public businessObjectDefinitionDescriptionSuggestionSearchBusinessObjectDefinitionDescriptionSuggestions(businessObjectDefinitionDescriptionSuggestionSearchRequest: BusinessObjectDefinitionDescriptionSuggestionSearchRequest, fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionDescriptionSuggestionSearchRequest === null || businessObjectDefinitionDescriptionSuggestionSearchRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionDescriptionSuggestionSearchRequest was null or undefined when calling businessObjectDefinitionDescriptionSuggestionSearchBusinessObjectDefinitionDescriptionSuggestions.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fields !== undefined && fields !== null) {
            queryParameters = queryParameters.set('fields', <any>fields);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDefinitionDescriptionSuggestionSearchResponse>(`${this.configuration.basePath}/businessObjectDefinitionDescriptionSuggestions/search`,
            businessObjectDefinitionDescriptionSuggestionSearchRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectDefinitionDescriptionSuggestion
     * Updates an existing business object definition description suggestion by key.
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param userId the user id
     * @param businessObjectDefinitionDescriptionSuggestionUpdateRequest the information needed to update the business object definition description suggestion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionDescriptionSuggestionUpdateBusinessObjectDefinitionDescriptionSuggestion(namespace: string, businessObjectDefinitionName: string, userId: string, businessObjectDefinitionDescriptionSuggestionUpdateRequest: BusinessObjectDefinitionDescriptionSuggestionUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionDescriptionSuggestion>;
    public businessObjectDefinitionDescriptionSuggestionUpdateBusinessObjectDefinitionDescriptionSuggestion(namespace: string, businessObjectDefinitionName: string, userId: string, businessObjectDefinitionDescriptionSuggestionUpdateRequest: BusinessObjectDefinitionDescriptionSuggestionUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionUpdateBusinessObjectDefinitionDescriptionSuggestion(namespace: string, businessObjectDefinitionName: string, userId: string, businessObjectDefinitionDescriptionSuggestionUpdateRequest: BusinessObjectDefinitionDescriptionSuggestionUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionDescriptionSuggestion>>;
    public businessObjectDefinitionDescriptionSuggestionUpdateBusinessObjectDefinitionDescriptionSuggestion(namespace: string, businessObjectDefinitionName: string, userId: string, businessObjectDefinitionDescriptionSuggestionUpdateRequest: BusinessObjectDefinitionDescriptionSuggestionUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionDescriptionSuggestionUpdateBusinessObjectDefinitionDescriptionSuggestion.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionDescriptionSuggestionUpdateBusinessObjectDefinitionDescriptionSuggestion.');
        }
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling businessObjectDefinitionDescriptionSuggestionUpdateBusinessObjectDefinitionDescriptionSuggestion.');
        }
        if (businessObjectDefinitionDescriptionSuggestionUpdateRequest === null || businessObjectDefinitionDescriptionSuggestionUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionDescriptionSuggestionUpdateRequest was null or undefined when calling businessObjectDefinitionDescriptionSuggestionUpdateBusinessObjectDefinitionDescriptionSuggestion.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectDefinitionDescriptionSuggestion>(`${this.configuration.basePath}/businessObjectDefinitionDescriptionSuggestions/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/userIds/${encodeURIComponent(String(userId))}`,
            businessObjectDefinitionDescriptionSuggestionUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
